export class Overlay {
    private $parentView: JQuery;
    protected $element: JQuery;

    constructor($parentView?: JQuery) {
        this.$parentView = $parentView === undefined ? $("body > .app") : $parentView;
        this.$element = $('<div class="overlay" />');
    }

    public show() {
        //dim background
        let dim = this.$parentView!.find("> .dim");
        if (dim.length === 0) dim = $('<div class="dim" />').appendTo(this.$parentView!);

        //attach overlay
        if (!this.$element.parent().is(this.$parentView)) this.$element.stop(true, false).appendTo(this.$parentView);

        dim[0].offsetHeight;
        dim.addClass("shown");

        this.$element[0].offsetHeight;
        this.$element.addClass("shown");
    }

    public hide(): Promise<void> {
        return new Promise((resolve) => {
            const dim = this.$parentView.find("> .dim");
            if (dim.length === 0) {
                resolve();
                return;
            }

            this.$element.addClass("nodelay")[0].offsetHeight;
            this.$element
                .stop(true, false)
                .removeClass("shown")
                .delay(600)
                .queue((e) => {
                    dim.remove();
                    this.$element.removeClass("nodelay").detach();
                    e();

                    resolve();
                });
            dim.removeClass("shown");
        });
    }
}
